import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ys-welcome" }
const _hoisted_2 = { class: "ys-welcome-main" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "ys-welcome-sub" }
const _hoisted_5 = {
  key: 0,
  class: "ys-install-card"
}
const _hoisted_6 = { class: "ys-install-title" }
const _hoisted_7 = { class: "ys-install-desc" }
const _hoisted_8 = {
  key: 0,
  class: "ys-install-steps"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  class: "ys-install-card"
}
const _hoisted_11 = {
  key: 0,
  class: "ys-install-steps"
}
const _hoisted_12 = {
  key: 0,
  class: "ys-welcome-actions"
}

import { computed, onMounted, ref } from 'vue'
import logoImg from '@/assets/images/brand/caion-logo-clear.png'
import { isFnaFlavor } from '@/config/appFlavor'
import {
  captureInstallSourceFromUrl,
  installedAppName,
  isStandaloneDisplay,
  promptInstall,
  usePwaInstall,
} from '@/composables/usePwaInstall'


export default /*@__PURE__*/_defineComponent({
  __name: 'EntryPage',
  setup(__props) {

const fnaMode = computed(() => isFnaFlavor())

const {
  isInstalled,
  installGuide,
  installPresence,
  installPresenceLabel,
  refreshInstalled,
} = usePwaInstall()
const showSteps = ref(false)

const mustInstall = computed(() => !fnaMode.value && !isStandaloneDisplay())
const showInstallCta = computed(() => !isInstalled.value)
const installLead = computed(() => {
  if (installPresence.value === 'installed') {
    return `홈 화면의 ${installedAppName()} 아이콘을 눌러 앱을 실행하세요.`
  }
  if (installPresence.value === 'installing') return '설치가 끝나면 이 화면이 설치됨으로 바뀝니다.'
  if (installPresence.value === 'unknown') {
    return '이 브라우저에서는 설치됐는지 확인하지 못합니다. 홈 화면에 아이콘이 있으면 그 아이콘으로 여세요.'
  }
  return '카이온은 설치한 앱에서만 사용할 수 있습니다.'
})

const onInstallClick = async () => {
  const result = await promptInstall(mustInstall.value ? { sheet: false } : undefined)
  if (result === 'manual' || result === 'external') showSteps.value = true
}

onMounted(() => {
  captureInstallSourceFromUrl()
  refreshInstalled()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(logoImg),
        alt: "카이온",
        class: "ys-logo-wordmark ys-logo-wordmark--lg"
      }, null, 8, _hoisted_3),
      _createElementVNode("p", _hoisted_4, _toDisplayString(fnaMode.value ? '회계담당·기관 영수증 관리' : '장기요양 업무 앱'), 1),
      (mustInstall.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", {
              class: _normalizeClass(["ys-install-state", `is-${_unref(installPresence)}`])
            }, _toDisplayString(_unref(installPresenceLabel)), 3),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(installPresence) === 'installed' ? '앱 실행' : '앱 설치'), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(installLead.value), 1),
            (showSteps.value && _unref(installPresence) !== 'installed' && _unref(installGuide)?.steps?.length)
              ? (_openBlock(), _createElementBlock("ol", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(installGuide).steps, (step, i) => {
                    return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(step), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_unref(installPresence) !== 'installed')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "ys-btn ys-btn-primary ys-install-btn",
                  disabled: _unref(installPresence) === 'checking' || _unref(installPresence) === 'installing',
                  onClick: onInstallClick
                }, _toDisplayString(_unref(installPresence) === 'installing' ? '설치 중' : '앱 설치'), 9, _hoisted_9))
              : _createCommentVNode("", true)
          ]))
        : (showInstallCta.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "ys-install-kicker" }, "앱 설치", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "ys-install-title" }, "앱 설치", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "ys-install-desc" }, " Chrome · Safari · 삼성 인터넷 · Edge 등 사용 중인 브라우저에서 홈 화면에 추가할 수 있어요. ", -1)),
              (_unref(installGuide)?.steps?.length)
                ? (_openBlock(), _createElementBlock("ol", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(installGuide).steps.slice(0, 3), (step, i) => {
                      return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(step), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "ys-btn ys-btn-primary ys-install-btn",
                onClick: onInstallClick
              }, " 앱 설치 ")
            ]))
          : _createCommentVNode("", true)
    ]),
    (!mustInstall.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("button", {
            type: "button",
            class: "ys-btn ys-btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/login')))
          }, " 로그인 "),
          (!fnaMode.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "ys-btn ys-btn-ghost",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/signup')))
              }, " 회원가입 "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})